<script>
// import CommunityUpdate from "@/components/dashboard/community_updates/rewardful_announcement.vue";
import { mapGetters } from "vuex";
import HomepageButton from "@/components/global/homepage_button.vue";
import { LMS_PROVIDERS, PLATFORMS } from "@/constants";
import CreateWorkspaceIntegrationModal from "@/views/dashboard/workspace-integration/modal/create-workspace-integration-modal.vue";
import { getWorkspaceProfileIdKey } from "@/utils/userUtils";
// import DashboardWhatsNew from "@/views/dashboard/components/dashboard_whats_new.vue";

export default {
  name: "DashboardView",

  components: {
    HomepageButton,
    // DashboardWhatsNew,
    // CommunityUpdate,
  },

  inject: ["workspacesProvider", "growthBook"],

  data() {
    return {
      hasUpgraded: "",
      providers: LMS_PROVIDERS,
      isSchoologyFeatureEnabled: false,
    };
  },
  computed: {
    ...mapGetters("config", ["features"]),

    user() {
      return this.$store.state.user;
    },
    email() {
      return this.growthBook?.attributes?.email;
    },
    workspaces() {
      return this.workspacesProvider.workspaces;
    },

    workspacesLoading() {
      return this.workspacesProvider.loadingFolders;
    },

    workspacesCount() {
      return Object.keys(this.workspaces).length;
    },

    isBulkImportsEnabled() {
      return this.features.bulkImports;
    },
  },
  watch: {
    email: {
      immediate: true,
      handler(newValue) {
        const value = this.growthBook?.getFeatureValue("schoology-enabled");

        this.isSchoologyFeatureEnabled =
          value === true || (Array.isArray(value) && value.includes(newValue));
      },
    },
  },
  async mounted() {
    // user was re-routed after upgrading plans
    if (this.$route.query.upgraded || this.$route.query.downgraded) {
      const upgradedPlan = this.$route.query.upgraded;
      const downgradedPlan = this.$route.query.downgraded;
      const plan = upgradedPlan || downgradedPlan;
      const key = downgradedPlan
        ? "account.subscription.downgradedSuccessfully"
        : "account.subscription.upgradedSuccessfully";
      this.hasUpgraded = this.$t(key, { plan });
    }
  },
  methods: {
    createWorkspaceIntegration(platformKey) {
      if (this.features.bulkImports && platformKey === PLATFORMS.CANVAS) {
        return this.$router.push({ name: "imports-canvas" });
      }

      const currentProfileId =
        this.$store.state.user[getWorkspaceProfileIdKey(platformKey)];

      if (currentProfileId) {
        this.navigateToImportAssignment(platformKey, currentProfileId);
        return;
      }

      this.$egModal.show("create-workspace-integration-modal", {
        component: CreateWorkspaceIntegrationModal,
        props: {
          platformKey: platformKey,
        },
        on: {
          onSuccess: (profileId) =>
            this.navigateToImportAssignment(platformKey, profileId),
        },
      });
    },
    handleManualSetup() {
      this.$router.push({ name: "manual-grading" });
    },
    navigateToRubricLibrary() {
      this.$router.push("/rubrics");
    },
    navigateToCreateRubric() {
      this.$router.push("/rubrics?openCreateRubric=true");
    },
    navigateToImportAssignment(platformKey, profileId) {
      this.$router.push({
        name: "imports-assignments",
        params: {
          platformKey: platformKey,
          id: profileId,
        },
      });
    },
  },
};
</script>

<template>
  <div class="welcome-container">
    <eg-b-overlay :show="workspacesLoading" no-wrap>
      <template #overlay>
        <eg-b-spinner small variant="info" />
      </template>
    </eg-b-overlay>
    <eg-b-container v-if="!workspacesLoading">
      <eg-b-row>
        <eg-b-col>
          <eg-b-alert v-if="hasUpgraded" variant="success" show>
            {{ hasUpgraded }}
          </eg-b-alert>

          <div class="welcome-titile">
            <div class="title">
              {{
                $t("dashboard.welcomeUser", {
                  name: user?.firstName || user?.email,
                })
              }}
            </div>
            <p v-if="workspacesCount === 0" class="subtitle">
              {{ $t("dashboard.letsSetupClassroom") }}
            </p>
            <p v-else class="subtitle">{{ $t("dashboard.letsGetGrading") }}</p>
          </div>
        </eg-b-col>
      </eg-b-row>
      <eg-b-row>
        <div class="frame" data-testid="home-import-student-submissions">
          <div class="header">
            <div class="heading">{{ $t("dashboard.importSubmissions") }}</div>
          </div>
          <div class="actions">
            <homepage-button
              :title="$t('dashboard.uploadManually')"
              :subtitle="$t('dashboard.importFromComputer')"
              icon="plus"
              @click="handleManualSetup"
            />
            <homepage-button
              v-if="!isBulkImportsEnabled"
              :title="$t('dashboard.googleClassroom')"
              :subtitle="$t('dashboard.importFromClassroom')"
              icon="classroom"
              @click="
                () => createWorkspaceIntegration(providers.googleClassroom.key)
              "
            />
            <homepage-button
              :title="$t('dashboard.canvas')"
              :subtitle="$t('dashboard.importFromCanvas')"
              icon="canvas"
              @click="() => createWorkspaceIntegration(providers.canvas.key)"
            />
            <homepage-button
              v-if="!isBulkImportsEnabled"
              :disabled="!isSchoologyFeatureEnabled"
              :title="$t('dashboard.schoology')"
              :subtitle="
                !isSchoologyFeatureEnabled
                  ? $t('dashboard.importFromSchoologyBeta')
                  : $t('dashboard.importFromSchoology')
              "
              icon="schoology"
              @click="() => createWorkspaceIntegration(providers.schoology.key)"
            />
          </div>
        </div>
      </eg-b-row>
      <eg-b-row class="mt-4">
        <div class="frame">
          <div class="header">
            <div class="heading">{{ $t("dashboard.setupRubrics") }}</div>
          </div>
          <div class="actions">
            <homepage-button
              :title="$t('dashboard.rubricLibrary')"
              icon="folders"
              @click="navigateToRubricLibrary"
            />
            <homepage-button
              :title="$t('dashboard.addYourOwnRubric')"
              icon="plus"
              @click="navigateToCreateRubric"
            />
          </div>
        </div>
      </eg-b-row>
      <!--  <dashboard-whats-new />-->
      <!-- No community updates for now -->
      <!-- <eg-b-row class="mt-4">
          <div class="frame">
            <div class="header">
              <div class="heading">Latest News &amp; Updates</div>
            </div>
            <community-update />
          </div>
        </eg-b-row> -->
    </eg-b-container>
  </div>
</template>

<style scoped lang="scss">
.welcome-container {
  font-family: Inter;

  .container {
    max-width: 992px;
    margin-bottom: 156px;
  }
  header {
    margin-bottom: 54px;
  }
  header h1 {
    font-size: 40px;
    font-style: normal;
    font-weight: 500;
    line-height: 48px;
    text-align: center;
    margin: 0 0 4px 0;
  }

  .welcome-sub-title {
    margin: 0;
    text-align: center;
    font-size: 16px;
    line-height: 24px;
  }
  .action-container {
    gap: 16px;
  }
  @media (max-width: 760px) {
    .container {
      max-width: 492px;
    }
  }
}
.community-update-container {
  max-width: 1110px;
  margin: 0 auto;
}

.welcome-titile {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 16px 0px 44px;
  position: relative;
}

.welcome-titile .title {
  position: relative;
  width: fit-content;
  margin-top: -1px;
  font-family: "Inter", Helvetica;
  font-weight: 600;
  color: #1c0f30;
  font-size: 32px;
  text-align: center;
  letter-spacing: 0px;
  line-height: 120%;
  white-space: nowrap;
  font-style: normal;
}

.welcome-titile .subtitle {
  position: relative;
  width: fit-content;
  font-family: "Inter", Helvetica;
  font-weight: 500;
  color: #566370;
  font-size: 20px;
  text-align: center;
  letter-spacing: 0px;
  line-height: 120%;
  white-space: nowrap;
  font-style: normal;
}

.frame {
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  position: relative;
  width: 100%;
}

.frame .header {
  display: flex;
  height: 36px;
  align-items: center;
  gap: 24px;
  position: relative;
  background-color: transparent;
}

.frame .heading {
  position: relative;
  width: fit-content;
  font-family: "Inter", Helvetica;
  font-weight: 600;
  color: #1c0f30;
  font-size: 20px;
  letter-spacing: 0px;
  line-height: 120%;
  white-space: nowrap;
  font-style: normal;
}

.frame .actions {
  display: flex;
  justify-content: center;
  gap: 16px;
  position: relative;
  align-self: stretch;
  width: 100%;
  flex: 0 0 auto;
}
</style>
